import {LoginSpec, PageFragment} from "../shared/PageFragment";
import {getMemberAuth} from "../shared/auth";
import React from "react";

export class RedirectProfileFragment extends PageFragment {

  protected createLoginSpec(): LoginSpec | null {
    return {
      needsLogin: true,
      redirectAfterLoginPath: "/profile",
    };
  }

  renderContent(): React.ReactElement {
    const username = getMemberAuth()?.member?.username;
    if (username) {
      this.props.path.navigate("/@" + username);
    }
    return null;
  }
}